// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"shipmentsToCompare_loadingSpinner__oxYlr","loading":"shipmentsToCompare_loading__bR1Ku"};